import { Box, Button, Card , Grid,  Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { commonService } from '../../services';

import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import EsquebraDetailModal from './EsquebraDetailModal';
import moment from 'moment';
const EsquebrasPage = () => {
  const { user } = useAuth();
  const [data, setData] = React.useState([]);
  const [esquebralModal,setEsquebraModal]=useState(false);
  const [currentEsquebraId,setCurrentEsquebraId]=useState(null);

  const navigate = useNavigate();
  React.useEffect(() => {
    commonService.esquebras().then((data) => {
      setData(data)
    })
  }, [])

  const handleCloseModal = ()=>{
    setEsquebraModal(false);
  }

  return (
    <React.Fragment>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant='h1' fontWeight={600}>Esquebras</Typography>
        </Grid>
        {data.map((item, index) => (
          <Grid item xs={4}>
            <Card sx={{ display: 'flex', p: 2 }}>
              <Box>
                <Typography fontWeight={900} color={'primary'}> {moment(item.online_from).format('YYYY-MM-DD')} - {moment(item.online_to).format('YYYY-MM-DD')} </Typography>
                <Typography variant='h1' pt={1}>{item.title}</Typography>
                <Box pt={1} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 20 }} >
                  <Button onClick={()=>{
                    setCurrentEsquebraId(item.id);
                    setEsquebraModal(true)
                  }} color='secondary2' variant='contained' disableElevation> Visualizar </Button>
                  <Button onClick={()=>{
                    navigate('/esquebras/usages?esquebraId='+item.id)
                  }}  color='secondary2' variant='contained' disableElevation> Ver Utilizações </Button>
                </Box>
                <Box display={'flex'} gap={4} mt={2}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <PersonOutlinedIcon />
                    <Typography variant="body2" textTransform={'uppercase'}>Limitado</Typography>
                  </Stack>
                </Box>
              </Box>
              <Box>
              </Box>
            </Card>
          </Grid>
        ))}
        <Grid item>
        {data.length==0?<Typography>Sem Esquebras disponível</Typography>:null}
        </Grid>
       {esquebralModal && <EsquebraDetailModal esquebraId={currentEsquebraId} handleClose={handleCloseModal} open={esquebralModal} />}
      </Grid>
    </React.Fragment>


  )
}

export default EsquebrasPage;